import { render } from "./EmojiSelector.vue?vue&type=template&id=a27cfbfa"
import script from "./EmojiSelector.vue?vue&type=script&lang=ts"
export * from "./EmojiSelector.vue?vue&type=script&lang=ts"
script.render = render

export default script